export default __webpack_public_path__ + "static/media/logo_usa.c6ea02c4.svg";